<script lang="ts">
	import { onMount } from 'svelte';
	import SearchIcon from 'assets/svg/searchIcon.svg?component';
	import NoIcon from 'assets/svg/noIcon.svg?url';
	import { goto } from '$app/navigation';
	import { onErrorCoinLogo } from 'utils/onErrorCoinLogo';
	import { _ } from 'utils/i18/i18n';
	import activeLocale from 'stores/activeLocale';
	import { getSearchCoinList } from 'services/search/searchCoin';

	$: normalizedLocale = $activeLocale.locale === 'en' ? '' : `/${$activeLocale.locale}`;

	export let query = '';
	export let dark: boolean;
	export let minWidth: number;
	export let isFromModal = false;
	export let handleWatchlist: () => void = () => {};
	export let list = [];

	let placeholder: string = $_('watchlist.search');

	let matches = [];
	let isListOpen = false;
	let searchRef;

	async function search() {
		if (query !== '') {
			matches = await getSearchCoinList(query, 'rank', 20, 'desc');
			isListOpen = matches.length > 0;
		} else {
			isListOpen = false;
		}
	}

	onMount(() => {
		document.addEventListener('click', handleClose);

		return () => {
			document.removeEventListener('click', handleClose);
		};
	});

	const handleClose = (e: Event) => {
		if (searchRef && !searchRef.contains(e.target)) {
			isListOpen = false;
		}
	};

	const  addToList = (symbol: string) => {
		if (list.includes(symbol)) {
			list = list.filter((s) => s !== symbol);
		} else {
			list = [...list, symbol];
		}
	}
</script>

<div class="wrapper" bind:this={searchRef} style="min-width: {minWidth}px">
	<div class="search-wrapper" class:dark class:not-empty={query} class:in-modal={isFromModal}>
		<input
			class="input"
			type="text"
			name={placeholder}
			{placeholder}
			bind:value={query}
			on:input={search}
			on:focus={() => {
				if (matches.length > 0 && query) {
					isListOpen = true;
				}
			}}
		/>
		<SearchIcon width="12" height="12" class="search-icon center" />
	</div>
	<!-- TODO: move list-wrapper to async to increase perf -->
	<div class="list-wrapper" class:visible={isListOpen} class:dark>
		<ul class="list">
			{#if matches.length > 0}
				{#each matches as item}
					<li
						class="list-item center"
						on:click={() => {
							if (!isFromModal) {
								goto(`/coins/${item.route}${normalizedLocale}`);
								isListOpen = false;
								query = '';
							} else {
								addToList(item._id);
								query = '';
								handleWatchlist();
								isListOpen = false;
							}
						}}
					>
						<span class="list-item-link">
							{#if item.logo_url}
								<img class="icon-logo" src={item.logo_url} alt="coin logo" on:error={onErrorCoinLogo} />
							{:else}
								<img class="icon-logo" src={NoIcon} alt="coin logo" />
							{/if}

							<p class="symbol">{item.symbol}</p>
							<p class="name">{item?.customName ?? item.name}</p>
						</span>
					</li>
				{/each}
			{:else}
				<li class="no-match">{$_('watchlist.noMatchesFound')}</li>
			{/if}
		</ul>
	</div>
</div>

<style lang="scss">
	@import 'coinSearch';
</style>
